module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/zhaolinxu/GitHub/IdleAnt/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0